import React from "react";
import { DialogRoot } from "components/ui/dialog";
import {
  DialogActionTrigger,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@chakra-ui/react";
import { Button } from "components/ui/button";
import { BASE_URL } from "utils/utils";
import profileImage from "../../../../assets/img/avatars/profileImage.jpg";

const ContractorDetails = ({ data }) => {
  const statusText = {
    pending: "قيد الانتظار",
    accepted: "مقبول",
    rejected: "مرفوض",
  };
  const statusColor = {
    pending: "text-yellow-500",
    accepted: "text-green-500",
    rejected: "text-red-500",
  };
  const chosenOffer = data?.contractorOffers?.find(
    (contractor) => contractor?.user?.id === data?.chosenContractor?.id
  );

  const locationLink = (location) => {
    if (!location?.lat || !location?.lng) return "—";
    const label = `${Number(location.lat).toFixed(5)}, ${Number(
      location.lng
    ).toFixed(5)}`;
    return (
      <a
        className="text-start hover:underline"
        href={`https://www.openstreetmap.org/?mlat=${location.lat}&mlon=${location.lng}#map=16/${location.lat}/${location.lng}`}
        target="_blank"
        rel="noreferrer"
      >
        {label}
      </a>
    );
  };

  return (
    <DialogRoot dir="rtl">
      <DialogTrigger asChild>
        <button
          className="rounded-md bg-blueSecondary py-2 px-4 text-white transition-all float-end hover:bg-brandLinear"
          variant="outline"
          size="sm"
        >
          تفاصيل
        </button>
      </DialogTrigger>
      <DialogContent className="fixed top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white text-gray-700 end-1/2 dark:bg-navy-800 dark:text-white">
        <DialogHeader>
          <DialogTitle className="text-center text-xl font-bold">
            التفاصيل
          </DialogTitle>
        </DialogHeader>
        <DialogBody className="max-h-[60vh] overflow-y-auto py-4">
          {data?.chosenContractor && (
            <div className="rounded-md border p-4 shadow-sm">
              {/* Image */}
              <h3 className="text-center text-2xl font-bold">
                المقاول المختار
              </h3>
              <div className="my-4 flex justify-center">
                <img
                  src={
                    data?.chosenContractor?.photo
                      ? `${BASE_URL}/${data?.chosenContractor?.photo}`
                      : profileImage
                  }
                  alt="contractor"
                  className="h-28 w-28 rounded-full border border-gray-200 object-cover"
                  crossOrigin="anonymous"
                />
              </div>
              <div className="mt-4 grid grid-cols-2 gap-4">
                {/* name */}
                <div className="flex-1">
                  <h4 className="mb-1 text-lg font-semibold">الاسم</h4>
                  <p>{data?.chosenContractor?.name}</p>
                </div>
                {/* email */}
                <div className="flex-1">
                  <h4 className="mb-1 text-lg font-semibold">
                    البريد الإلكتروني
                  </h4>
                  <a
                    className="hover:underline"
                    href={`mailto:${data?.chosenContractor?.contractorInfo?.email}`}
                  >
                    {data?.chosenContractor?.contractorInfo?.email}
                  </a>
                </div>
                {/* phone */}
                <div className="flex-1">
                  <h4 className="mb-1 text-lg font-semibold">الهاتف</h4>
                  <a
                    className="hover:underline"
                    href={`tel:${data?.chosenContractor?.phoneNumber}`}
                  >
                    {data?.chosenContractor?.phoneNumber}
                  </a>
                </div>
                {/* address */}
                <div className="flex-1">
                  <h4 className="mb-1 text-lg font-semibold">العنوان</h4>
                  {locationLink(data?.chosenContractor?.location)}
                </div>
                {chosenOffer && (
                  <>
                    <div className="flex-1">
                      <h4 className="mb-1 text-lg font-semibold">من السعر</h4>
                      <p>{chosenOffer?.fromPrice} ريال</p>
                    </div>
                    <div className="flex-1">
                      <h4 className="mb-1 text-lg font-semibold">إلى السعر</h4>
                      <p>{chosenOffer?.toPrice} ريال</p>
                    </div>
                    <div className="col-span-2">
                      <h4 className="mb-1 text-lg font-semibold">الحالة</h4>
                      <p
                        className={`${
                          statusColor[chosenOffer.status]
                        } font-semibold`}
                      >
                        {statusText[chosenOffer.status]}
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
          {data?.contractorOffers?.length > 0 && (
            <div className="mt-4 rounded-md border p-4 shadow-sm">
              <h3 className="text-center text-2xl font-bold">
                المقاولين المقبولين
              </h3>
              <div className="mt-4 grid grid-cols-2 gap-4">
                {data?.contractorOffers.map((contractor, index) => (
                  <div key={index} className="rounded-md border p-4 shadow-sm">
                    <div className="mb-4 flex justify-start">
                      <img
                        src={`${BASE_URL}/${contractor?.user?.photo}`}
                        alt="contractor"
                        className="h-20 w-20 rounded-xl border border-gray-200 object-cover"
                        crossOrigin="anonymous"
                      />
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="flex-1">
                        <h4 className="mb-1 text-lg font-semibold">الاسم</h4>
                        <p className="text-gray-500">
                          {contractor?.user?.name}
                        </p>
                      </div>
                      <div className="flex-1">
                        <h4 className="mb-1 text-lg font-semibold">
                          البريد الإلكتروني
                        </h4>
                        <a
                          className="text-gray-500 hover:underline"
                          href={`mailto:${contractor?.user?.contractorInfo?.email}`}
                        >
                          {contractor?.user?.contractorInfo?.email}
                        </a>
                      </div>
                      <div className="flex-1">
                        <h4 className="mb-1 text-lg font-semibold">الهاتف</h4>
                        <a
                          className="text-gray-500 hover:underline"
                          href={`tel:${contractor?.user?.phoneNumber}`}
                        >
                          {contractor?.user?.phoneNumber}
                        </a>
                      </div>
                      <div className="flex-1">
                        <h4 className="mb-1 text-lg font-semibold">العنوان</h4>
                        {locationLink(contractor?.user?.location)}
                      </div>
                      <div className="flex-1">
                        <h4 className="mb-1 text-lg font-semibold">من السعر</h4>
                        <p className="text-gray-500">
                          {contractor?.fromPrice} ريال
                        </p>
                      </div>
                      <div className="flex-1">
                        <h4 className="mb-1 text-lg font-semibold">
                          إلى السعر
                        </h4>
                        <p className="text-gray-500">
                          {contractor?.toPrice} ريال
                        </p>
                      </div>
                      <div className="col-span-2">
                        <h4 className="mb-1 text-lg font-semibold">الحالة</h4>
                        <p
                          className={`${
                            statusColor[contractor?.status]
                          } font-semibold`}
                        >
                          {statusText[contractor?.status]}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {data?.contractorOffers?.length === 0 &&
            !data?.chosenContractor && (
              <p className="text-center">لا يوجد مقاولين</p>
            )}
        </DialogBody>
        <DialogFooter>
          <DialogActionTrigger asChild>
            <Button variant="outline">
              <span>إغلاق</span>
            </Button>
          </DialogActionTrigger>
        </DialogFooter>
        <DialogCloseTrigger />
      </DialogContent>
    </DialogRoot>
  );
};

export default ContractorDetails;
